import React from 'react';
import { PermisionDenied } from '../../../../views/pages/manage/common/commonComponents';
import TransferApprovalConfigsListing from './TransferApprovalConfigsListing';
import { useGetPermissions } from '../../../../layouts/customHook';

const TransferApprovalConfiguration = () => {

    const userPermissions = useGetPermissions('transferApprovalConfig');
    return (
        userPermissions
            ? <TransferApprovalConfigsListing userPermissions={userPermissions}/>
            : <PermisionDenied />
    );
}

export default TransferApprovalConfiguration;